import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './Loading.module.scss'

export const Loading = (props) => {
  const { variant = 'line', size = 'sm', invert, ...rest } = props

  const dotClass = classNames(styles.dot, {
    [styles[size]]: size,
    [styles.invert]: invert,
  })

  const circleLoadingSize = {
    sm: '1rem',
    md: '2rem',
    xs: '.8rem',
  }[size]

  return (
    <div
      className={styles.loadingWrapper}
      {...rest}
      data-testid="auto-id-c4f7ad62-0982-4b22-8a97-bf2af9fccc67"
    >
      {variant === 'dots' && (
        <ul
          className={styles.dotsList}
          data-testid="auto-id-0311a0a9-e65b-4c37-8e2f-e12272716444"
        >
          <li data-testid="dot" className={dotClass} />
          <li data-testid="dot" className={dotClass} />
          <li data-testid="dot" className={dotClass} />
        </ul>
      )}
      {variant === 'circle' && (
        <div data-testid="circle" className={styles.circleContent}>
          <div
            className={classNames(styles.circleLoading, {
              [styles.invert]: invert,
            })}
            style={{ width: circleLoadingSize, height: circleLoadingSize }}
            data-testid="auto-id-52e0da60-93b1-474f-98dc-04c2f1284d5e"
          />
        </div>
      )}
      {variant === 'line' && (
        <div data-testid="line" className={styles.loaderLine} />
      )}
    </div>
  )
}

Loading.size = { sm: 'sm', md: 'md', xs: 'xs' }
Loading.variant = { dots: 'dots', circle: 'circle', line: 'line' }

Loading.propTypes = {
  size: PropTypes.oneOf(Object.values(Loading.size)),
  variant: PropTypes.oneOf(Object.values(Loading.variant)),
  className: PropTypes.string,
  invert: PropTypes.bool,
}

export default Loading
